<template>
  <div class="guide">
    <!-- <div class="guide-box">
      <svg class="icon icon-logo" aria-hidden="true">
        <use xlink:href="#icon-logo"></use>
      </svg>
      <div class="guide-slogn">
        <span>House730.com</span>
        <span>{{lang.slogn}}</span>
      </div>
      <a class="guide-open" href="house730://house730.com?type=0">{{lang.open}}</a>
    </div> -->
  </div>
</template>

<script>
import lang from "./../../common/language/login";
export default {
  name: "Guide",
  data() {
    return {
      lang: lang
    };
  }
};
</script>

<style  lang="scss" scoped>
@import "./../../common/css/common.scss";
.guide {
  width: 100%;
  border-bottom: solid 1px #ececec;
  .icon-logo {
    font-size: 42px;
  }
  .guide-box {
    position: relative;
    // display: flex;
    align-items: center;
    flex-direction: row;
    padding: 8px 10px 8px 15px;
    img {
      width: 40px;
      height: 40px;
    }
    .guide-slogn {
      display: flex;
      flex-direction: column;
      text-align: left;
      padding-left: 10px;
      color: gray;
      font-size: 14px;
    }

    .guide-open {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 17px;
      color: #4482ff;
      font-weight: 600;
    }
  }
}
</style>
